<h2 mat-dialog-title>Select Profile</h2>

<mat-dialog-content>
  <ng-container *ngIf="profiles.length > 0; else noProfiles">
    <mat-selection-list [(ngModel)]="selectedProfiles">
      <mat-list-option *ngFor="let profile of profiles" [value]="profile">
        {{ profile.name }}
      </mat-list-option>
    </mat-selection-list>
  </ng-container>

  <ng-template #noProfiles>
    <p>All profiles have already been added to the ACL.</p>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="dialogRef.close()">
    Cancel
  </button>

  <button
    mat-raised-button
    color="primary"
    (click)="addSelectedProfiles()"
    [disabled]="profiles.length === 0"
  >
    Add
  </button>
</mat-dialog-actions>
